import React from "react"
import { Col, Input, Row } from "reactstrap"
import { useState } from "react"
import { SaveButton } from "components/Buttons"

const Notes = props => {
  const [note, setNote] = useState(props.note || "")

  const isChanged = props.note ? props.note != note : note

  return (
    <Row>
      <Col>
        <h5 className="font-size-14 mb-0">
          <i className="mdi mdi-arrow-right text-primary"></i>
          Notes
        </h5>
        <Row>
          <Col className="my-3">
            <Input
              type="textarea"
              onChange={({ target: { value } }) => setNote(value)}
              value={note}
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              onClick={() => props.handleNoteSave(note)}
              loading={props.saveLoading}
              disabled={!isChanged}
            >
              Save
            </SaveButton>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Notes
